import "./ExtrasSection.scss";

export const ExtrasSection = () => {
  return (
    <section id="extras" className="extras-section">
      <div className="extras-card">
        <div className="extras-header">
          <h2>Még valami...</h2>

          <p>
            Mielőtt találkozunk, még két apróság.
          </p>
        </div>

        <div className="extras-grid">

          <article className="extra-item">
            <div className="extra-icon">🎁</div>

            <h3>Nászajándék</h3>

            <p>
              Számunkra a legnagyobb ajándék, hogy velünk
              ünnepeltek.
            </p>

            <p className="extra-highlight">
              Ajándékon ne törd a fejed,
              <br />
              egy borítékban elrejtheted!
            </p>
          </article>

          <div className="extras-divider" />

          <article className="extra-item">
            <div className="extra-icon-sound">♫</div>

            <h3>Hangolódj a bulira</h3>

            <p>
              Ha hangolódnál a bulira,
              szemezgess a kedvenc
              slágereinkből, amelyek
              biztosan felcsendülnek
              majd az este során!
            </p>

            <a
              href="https://youtube.com/playlist?list=PLsqGPVF2DFN2dgtwLt3HIX1TyPgglGBcN&si=RJNo4MY4oB4yrmVj"
              target="_blank"
              rel="noreferrer"
              className="spotify-button"
            >
              ♫ Lejátszási lista
            </a>
          </article>

        </div>

        <div className="extras-footer">

            <div className="footer-divider">
                <span />
                <div className="diamond" />
                <span />
            </div>

            <p className="signature-message">
                Nagyon várjuk, hogy Veletek ünnepelhessünk.
            </p>


            <div className="footer-divider">
                <span />
                <div className="diamond" />
                <span />
            </div>

            <div className="signature-monogram">
                <span className="letter">V</span>

                <span className="ampersand">&amp;</span>

                <span className="letter">R</span>
            </div>

        </div>

      </div>
    </section>
  );
};